import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var StarFilledIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "m12 20.048-5.622 2.974a1 1 0 0 1-1.453-1.052L6 15.66 1.44 11.188a1 1 0 0 1 .556-1.704l6.297-.92 2.81-5.732a1 1 0 0 1 1.796 0l2.81 5.731 6.297.921a1 1 0 0 1 .556 1.704l-4.562 4.474 1.076 6.31a1 1 0 0 1-1.454 1.051L12 20.048Z"
        })
    }));
};
